export interface MaterialVendor {
  vendorId: string;
  vendorName: string;
}
